import {ShiftType} from "@/graphql/generated/graphql";
import {defineStore} from "pinia";
import {kapitelMonthString} from "@/graphql/kapitelTypes";
import {fetchCurrentPlanningStatus, fetchCurrentPlanningStatusWithPrecrime} from "@/helper/autopilotStatus";
import {useAppState} from "@/helper/appState";
import month from "@/helper/datetime/month";
import date from "@/helper/datetime/date";

let ensureInitDone = false

interface DemandFilterSelection {
    month: kapitelMonthString,
    shiftSelection: ShiftType[]
}

export const defaultMonth = () => month.getCurrentKapitelMonth()
export const defaultShiftSelection = () => [ShiftType.Fd]

export const useDemandBrowserFilterSelectionStore = defineStore("demandBrowserFilterSelection", {
    persist: false,
    state: (): DemandFilterSelection => ({
        month: defaultMonth(),
        shiftSelection: defaultShiftSelection(),
    }),
    actions: {
        async ensureInit() {
            if (ensureInitDone) {
                return
            }
            await this.reset()
            ensureInitDone = true
        },
        async reset () {
            this.setMonth(defaultMonth())
            this.setShifts(defaultShiftSelection())
            if(useAppState().isEmployeeOrCandidate('employee')){
                const planningStatuses = await fetchCurrentPlanningStatusWithPrecrime()
                const latestStatus = planningStatuses.reduce((latest, current) => {
                    if (!latest) {
                        return current
                    }
                    return date.cmpKapitelDate(current.month, latest.month) > 0 ? current : latest
                }, undefined as typeof planningStatuses[number] | undefined)
                const autopilotPortfolio = latestStatus?.shiftPortfolio
                if (autopilotPortfolio) {
                    this.setShifts(autopilotPortfolio)
                }
            }
        },
        setMonth(month: kapitelMonthString) {
            this.month = month
        },

        setShifts(shiftSelection: ShiftType[]) {
            this.shiftSelection.splice(0, this.shiftSelection.length, ...shiftSelection)
        }
    }
});
